import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchCriteriaDataService {
  private localStorageKey = environment.apiBaseUrl + '-SearchCriteria';
  loginErrorMessage:string;
  constructor() { }

  getSharedData(): any {
    const dataString = localStorage.getItem(this.localStorageKey);
    return dataString ? JSON.parse(dataString) : {};
  }

  getLoginPageErrMsg() {
    return this.loginErrorMessage;
  }

  setSharedData(data: any) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  getValue(key: string): any {
    const data = this.getSharedData();
    return data[key];
  }

  setValue(key: string, value: any,sessionType?:any) {
    const data = this.getSharedData();
    data[key] = value;
    this.setSharedData(data);
  }

  clearSharedData() {
    localStorage.removeItem(this.localStorageKey);
  }
  removeParticularItem(key: string) {
    const data = this.getSharedData();
    if (data.hasOwnProperty(key)) {
        delete data[key];
        localStorage.removeItem(key);
    }
    this.setSharedData(data);
}
}
